import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import { AgGridVue } from 'ag-grid-vue';

import Element from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';



import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-enterprise';

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
//时间选择组件
import DateTimeInterval from '@/components/DateTimeInterval/DateTimeInterval'

//el-select组件分页加载
Vue.directive('loadmore', {
    bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', function (e) {
            let target = e.target
            const CONDITION = target.scrollHeight - target.scrollTop <= target.clientHeight + 6
            if (CONDITION) {
                binding.value()
            }
        })
    }
}) 

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

/**
 * 防止el-button重复点击
 * 在按钮上添加v-preventReClick属性
 * <el-button @click="save" v-preventReClick>保存</el-button>
 */
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        el.style.cursur = "not-allowed";
        setTimeout(() => {
          el.disabled = false;
          el.style.cursor = "pointer";
        }, binding.value || 2000);
      }
    });
  },
});

//图片裁剪
// import "@scss/index_y.scss";
import VueCropper from "vue-cropper";
Vue.use(VueCropper);

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component('AgGridVue', AgGridVue)
Vue.component('DateTimeInterval', DateTimeInterval)

// 全局 Message 包装（在 Element 安装后覆盖默认实现），设置默认 offset 为 60、duration 为 5000ms
const _elementMessage = Message;
function messageWrapper(options) {
  if (typeof options === 'string') {
    options = { message: options };
  }
  options = Object.assign({ offset: 60, duration: 2000 }, options);
  return _elementMessage(options);
}
['success', 'warning', 'info', 'error'].forEach(type => {
  messageWrapper[type] = function(options) {
    if (typeof options === 'string') {
      options = { message: options };
    }
    options = Object.assign({ type, offset: 60, duration: 2000 }, options);
    return _elementMessage(options);
  }
});
Vue.prototype.$message = messageWrapper;

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
